import React from "react";
import "./style.css";
function index(props) {
  return (
    <div className="delete-confirm-container">
      <div className="delete-box">
        <h3>Do you really want to delete</h3>
        <p>By Pressing Confirm. you agree that this reaction is not reversible</p>
        <div className="btn-box">
          <button onClick={props.onCancel}>Cancel</button>
          <button onClick={props.onConfirm}>Confirm</button>
        </div>
      </div>
    </div>
  );
}

export default index;
